// 评估是否是预渲染运行态，注入时机参考 vue.config.js
export default (): boolean => !!(
  (window.__DEPRECATION_PRERENDER_INJECTED && window.__DEPRECATION_PRERENDER_INJECTED.isBuilding)
  || window.__PRERENDER_INJECTED
);

/** 是否是即将弃用预渲染运行环境 */
export const isDeprecationPrerendering = (): boolean => !!(
  (window.__DEPRECATION_PRERENDER_INJECTED && window.__DEPRECATION_PRERENDER_INJECTED.isBuilding)
);
